import { createRequest, getEndpoint } from "../requestCreator";

export const createSystemDefinition = createRequest(getEndpoint("systems.sub.create"));
export const getSystemDefinitions = createRequest(getEndpoint("systems.sub.get"));
export const countSystemDefinitions = createRequest(getEndpoint("systems.sub.count"));
export const deleteSystemDefinition = createRequest(getEndpoint("systems.sub.delete"));
export const updateSystemDefinition = createRequest(getEndpoint("systems.sub.update"), {
  pathCreator: (path, params) => `${path.replace(":id", `${params.id}`)}`,
});
